import makeStyles from '@material-ui/core/styles/makeStyles';
import withStyles from '@material-ui/core/styles/withStyles';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

export const useStyles = makeStyles(theme => ({
  cardViewWrapper: {
    overflow: 'auto',
  },
  checkboxCell: {
    'td&': {
      minWidth: 'unset',
    },
  },
  descendingSortIcon: {
    transform: 'rotate(180deg)',
    marginLeft: -8,
    width: 8,
  },
  sortIconWrapper: {
    marginLeft: 12,
    width: 10,
    height: 19,
  },
  sortIcon: {
    width: 8,
    position: 'relative',
    bottom: 5,
  },
  paginationItems: {
    fontWeight: 'normal',
    padding: 0,
    color: theme.palette.grey[800],
  },
  resizeIconWrapper: {
    width: 2,
    cursor: 'col-resize',
    userSelect: 'none',
    visibility: 'hidden',
  },
  resizeIcon: {
    background: theme.palette.background.defaultLightGrey,
    opacity: 0.6,
    width: 2,
    height: 15,
  },
  rowDivider: {
    borderBottom: `1px solid ${theme.palette.grey['400']}`,
  },
  expandIcon: {
    transform: 'rotate(-90deg)',
  },
  expandRotate: {
    transform: 'rotate(180deg)',
  },
}));

export const StyledTableCell = withStyles(theme => ({
  head: {
    border: 'none',
    padding: '4px 0px 12px',
    paddingLeft: '10px',
    verticalAlign: 'middle',
    color: theme.palette.grey['600'],
    fontFamily: theme.font.semiBold,
    backgroundColor: theme.palette.common.white,
  },
  body: {
    padding: '11px 10px',
    color: theme.palette.text.primary,
    verticalAlign: 'middle',
    border: 'none',
    // fontFamily: theme.font.secondary,
    minWidth: 80,
    maxWidth: 300,
    '& p': {
      maxWidth: '95%',
    },
  },
}))(TableCell);

export const StyledTableRow = withStyles(theme => ({
  root: {},
}))(TableRow);

export const StyledTableHeaderRow = withStyles(theme => ({
  root: {
    // backgroundColor: theme.palette.action.hover,
  },
}))(TableRow);
